import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { orderApi } from "../api/orderApi";
import AdminSidebar from "../components/AdminSidebar";
import Message from "../components/Message";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    orderApi.getDashboard().then((data) => {
      setStats(data);
    }).catch((error) => setNotice({ type: "error", text: error.message }));
  }, []);

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1>Dashboard</h1>
          <p>Welcome to IoTBay Admin Panel</p>
        </div>
        <Message notice={notice} />

        {stats && (
          <>
            <div className="statistics-grid">
              <div className="stat-card"><div className="stat-icon">📦</div><div className="stat-info"><h3>Total Orders</h3><p className="stat-value">{stats.total_orders}</p></div></div>
              <div className="stat-card"><div className="stat-icon">👥</div><div className="stat-info"><h3>Total Customers</h3><p className="stat-value">{stats.total_users}</p></div></div>
              <div className="stat-card"><div className="stat-icon">💰</div><div className="stat-info"><h3>Total Revenue</h3><p className="stat-value">${Number(stats.total_revenue || 0).toFixed(2)}</p></div></div>
            </div>

            <div className="dashboard-sections">
              <div className="dashboard-section">
                <h2>Quick Actions</h2>
                <div className="quick-actions">
                  <Link to="/admin-orders" className="quick-action-btn">View All Orders</Link>
                  <Link to="/admin-payments" className="quick-action-btn">View Payments</Link>
                  <Link to="/admin-products" className="quick-action-btn">Manage Products</Link>
                  <Link to="/admin-users" className="quick-action-btn">Manage Users</Link>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
